import React, { useState } from "react";
import "./DeleteDialogStyleSheet.css";
interface ConfirmDeleteArtworkDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => Promise<void> | void;
    artworkTitle: string;
    artworkRef?: string; // e.g. inventory number or code (optional)
}

export const ConfirmDeleteArtworkDialog: React.FC<ConfirmDeleteArtworkDialogProps> = ({
    isOpen,
    onClose,
    onConfirm,
    artworkTitle,
    artworkRef,
}) => {
    const [isChecked, setIsChecked] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState<string | null>(null);

    if (!isOpen) return null;

    const handleConfirm = async () => {
        if (!isChecked || isSubmitting) return;

        try {
            setIsSubmitting(true);
            setError(null);
            await onConfirm();
            onClose();
        } catch (err: any) {
            setError("There was a problem deleting this artwork. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="delete-dialog-backdrop">
            <div className="delete-dialog">
                <h2 className="delete-dialog__title">Delete artwork?</h2>

                <p className="delete-dialog__summary">
                    You are about to permanently delete the following artwork:
                </p>

                <div className="delete-dialog__artwork">
                    <div className="delete-dialog__artwork-title">{artworkTitle}</div>
                    {artworkRef && (
                        <div className="delete-dialog__artwork-ref">
                            Reference Id: {artworkRef}
                        </div>
                    )}
                </div>

                <p className="delete-dialog__warning">
                    This will permanently remove:
                    <br />
                    – The artwork record
                    <br />
                    – All notes, references, and provenance entries
                    <br />
                    – All valuations
                    <br />
                    – Portfolio associations
                    <br />
                    – Linked images
                    <br />
                    <strong>This action cannot be undone.</strong>
                </p>

                <label className="delete-dialog__checkbox-row">
                    <span>
                        I understand that this artwork and all related data will be permanently
                        deleted.
                    </span>
                    <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={(e) => setIsChecked(e.target.checked)}
                    />
                    
                </label>

                {error && <div className="delete-dialog__error">{error}</div>}

                <div className="delete-dialog__actions">
                    <button
                        type="button"
                        className="delete-dialog__cancel"
                        onClick={onClose}
                        disabled={isSubmitting}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="delete-dialog__confirm"
                        onClick={handleConfirm}
                        disabled={!isChecked || isSubmitting}
                    >
                        {isSubmitting ? "Deleting…" : "Delete Artwork"}
                    </button>
                </div>
            </div>
        </div>
    );
};
